import { render, staticRenderFns } from "./RenewalDeadline.vue?vue&type=template&id=1b854fbe&scoped=true&"
import script from "./RenewalDeadline.vue?vue&type=script&lang=js&"
export * from "./RenewalDeadline.vue?vue&type=script&lang=js&"
import style0 from "./RenewalDeadline.vue?vue&type=style&index=0&id=1b854fbe&lang=scss&scoped=true&"
import style1 from "./RenewalDeadline.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b854fbe",
  null
  
)

export default component.exports